import { getUserCountry } from '../theme-scripts.js';

class SpecialNoticeModal extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector('.special-notice-modal__close');
    this.closeModalBtn = this.querySelector('[data-close-modal-btn]');
    this.affectedCountry = this.getAttribute('country-trigger');
    this.sessionKey = 'specialNoticeModalShown';
  }

  connectedCallback() {
    if (this.affectedCountry) {
      this.init();
    }
  }

  async init() {
    const hasBeenShown = sessionStorage.getItem(this.sessionKey);
    if (hasBeenShown) {
      return;
    }

    try {
      const userCountry = await getUserCountry();

      if (userCountry && userCountry.toUpperCase() === this.affectedCountry.toUpperCase()) {
        // Check if store selector popover exists and is open
        const storeSelector = document.querySelector('store-selector-popover');
        if (storeSelector && storeSelector.matches(':popover-open')) {
          // Wait for store selector to be dismissed
          const onStoreSelectorClose = () => {
            storeSelector.removeEventListener('close-store-selector', onStoreSelectorClose);
            this.show();
            this.setupEventListeners();
          };
          storeSelector.addEventListener('close-store-selector', onStoreSelectorClose);
        } else {
          // No store selector or it's already closed, proceed normally
          this.show();
          this.setupEventListeners();
        }
      }
    } catch (error) {
      console.error('Error initializing Special Notice Modal:', error);
    }
  }

  setupEventListeners() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', (event) => {
        event.stopPropagation();
        this.hide();
      });
    }

    if (this.closeModalBtn) {
      this.closeModalBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        this.hide();
      });
    }

    // Handle popover backdrop clicks
    if (this.hasAttribute('popover')) {
      this.addEventListener('toggle', (event) => {
        if (event.newState === 'open') {
          const redirectPopup = document.querySelector('store-selector-popover') || false;
          document.addEventListener('click', (event) => {
            if (!redirectPopup.matches(':popover-open') || redirectPopup == false) {
              if (!this.contains(event.target)) { this.hide(); }
            }
          });
        }
      });
    }
  }

  show() {
    if (this.hasAttribute('popover')) {
      this.showPopover();
    }
  }

  hide() {
    if (this.hasAttribute('popover')) {
      this.hidePopover();
      sessionStorage.setItem(this.sessionKey, 'true');
    }
  }
}

customElements.define('special-notice-modal', SpecialNoticeModal);